import translate from '@allesauto/i18n';
import { FinanceType } from '@allesauto/utils/consts';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import Footer from '../../OverlayFormFooter/OverlayFormFooter';

interface FinanceDetailsOverlayProps {
  summaryText?: string;
  legalText?: string;
  vehicleName: string;
  financeTypeText: string;
  financeType?: FinanceType;
  vehicleId?: string;
  vehicleModel?: string;
  vehicleMark?: string;
  closeOverlay: () => void;
  buttonText?: string;
}

const FinanceDetailsOverlay: FC<
  React.PropsWithChildren<FinanceDetailsOverlayProps>
> = (props) => {
  const {
    closeOverlay,
    legalText,
    summaryText,
    vehicleName,
    financeTypeText,
    buttonText,
  } = props;
  const intl = useIntl();

  const formatLegalText = legalText ? legalText.replace('* ', '') : undefined;

  return (
    <div>
      <div className="flex flex-col">
        <p
          className="font-regular font-weight-bold text-p2"
          dangerouslySetInnerHTML={{
            __html: translate(intl, 'ui.FINANCE_DETAILS.OVERLAY.SUMMARY_TEXT', {
              financeType: financeTypeText,
              vehicleName,
              summaryText: summaryText || '',
            }),
          }}
        />
        {formatLegalText ? (
          <p className="font-regular mt-20px text-p2">{formatLegalText}</p>
        ) : (
          <p className="pt-20px">
            {financeTypeText === FinanceType.LEASING
              ? translate(intl, 'ui.FINANCE_DETAILS.OVERLAY.LEASING_TEXT')
              : translate(intl, 'ui.FINANCE_DETAILS.OVERLAY.FINANCING_TEXT')}
          </p>
        )}
      </div>
      <Footer
        buttonText={
          buttonText
            ? buttonText
            : translate(intl, 'ui.INFORMATION_OVERLAYS.CLOSE_BUTTON')
        }
        onButtonClick={closeOverlay}
        className="mt-[120px]"
      ></Footer>
    </div>
  );
};

export default FinanceDetailsOverlay;
